<div class="pdf-container" fxFlexFill>
  <iframe *ngIf="url" [src]="url"></iframe>
</div>
